// extracted by css-extract-rspack-plugin
export default {"contractExtraModal":"contractExtraModal-PYmCgy"};